import produce from 'immer';

// // UTILS
// import { formatDate } from 'utils/genericFunctions';

// TYPES
import { Types, ConsultaRenovacaoCnh } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaRenovacaoCnh = {
	status: 0,
	data: null,
	dataError: null,
	requestData: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaRenovacaoCnh {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_RENOVACAO_CNH_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			case Types.CONSULTA_RENOVACAO_CNH_SUCCESS: {
				draft.requestData = action.payload.request;
				draft.data = action.payload.response.data;
				draft.status = action.payload.response.status;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			case Types.CONSULTA_RENOVACAO_CNH_FAILURE: {
				draft.requestData = action.payload.request;
				draft.dataError = action.payload.response.data;
				draft.status = action.payload.response.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTA_RENOVACAO_CNH_CLEAR: {
				draft.requestData = INITIAL_STATE.requestData;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
